import React, { createContext, useContext, useState } from "react";
import { IntlProvider } from "react-intl";
import enMessages from "./locales/en.json";
import roMessages from "./locales/ro.json";

const messages = {
  en: enMessages,
  ro: roMessages,
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState("ro"); // Default language is English

  const switchLanguage = (lang) => setLocale(lang);

  return (
    <LanguageContext.Provider value={{ locale, switchLanguage }}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {children}
      </IntlProvider>
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
